let chartStatusX = 0, chartStatusY=0;
const LINES = 2;
const CELLS = 10;
const PADS = 20;

const types = [
	['#f00', '#0004'],
	['#0f0', '#f006'],
	['#f00', '#0f06'],
]

const DEBUG = false;

const clearChart = () => {
	if(!DEBUG) return;
	const c = document.getElementById('canvas').getContext('2d');
	c.fillStyle = '#fff';
	c.clearRect(0,0,c.canvas.width, c.canvas.height);
}

const drawChart = (lines, cells, count, newLine, type=0) => {
	if(!DEBUG) return;
	if(newLine) {
		chartStatusX = 0;
		chartStatusY++;
	}
	const c = document.getElementById('canvas').getContext('2d');
	c.strokeStyle = types[type][0];
	c.lineWidth = LINES;
	c.fillStyle = types[type][1];
	let WHOLES = CELLS * (count+2)
	for(let ce of cells) {
		// c.fillRect(ce.x*CELLS+PADS+chartStatusX*WHOLES, ce.y*CELLS+PADS+chartStatusY*WHOLES, CELLS, CELLS);
	}
	for(let l of lines) {
		/*
		c.moveTo(l.x*CELLS+PADS+chartStatusX*WHOLES, l.y*CELLS+chartStatusY*WHOLES+PADS);
		c.lineTo(
			l.x*CELLS+(l.isH?0:CELLS)+chartStatusX*WHOLES+PADS,
			l.y*CELLS+(l.isH?CELLS:0)+chartStatusY*WHOLES+PADS
		);
		*/
		c.fillRect(
			l.x*CELLS+chartStatusX*WHOLES+PADS-LINES/2,
			l.y*CELLS+chartStatusY*WHOLES+PADS-LINES/2,
			l.isH?LINES:CELLS+LINES,
			l.isH?CELLS+LINES:LINES,
		);
	}
	c.fillStyle = '#000'
	for(let i=0; i<=count; i++) {
		for(let j=0; j<=count; j++) {
			c.fillRect(
				PADS+chartStatusX*WHOLES+i*CELLS-LINES/2,
				PADS+chartStatusY*WHOLES+j*CELLS-LINES/2,
				LINES, LINES,
			)
		}
	}
	c.stroke();
	chartStatusX++;
}

const getLinesOfCell = (count, lines, x, y) => {
	const al = [];
	for(let l of lines) {
		if((l.x===x || l.x===x+1) && l.y===y && l.isH || l.x===x && (l.y===y || l.y===y+1) && !l.isH) {
			al.push(l);
		}
	}
	return al;
}

const getCells = (count, lines, existingCells) => {
	const cells = [];
	for(let i=0; i<count; i++) {
		for(let j=0; j<count; j++) {
			const ls = getLinesOfCell(count, lines, i, j);
			if(ls.length===4) {
				let latestLine = null;
				for(const line of ls) {
					if(!latestLine || line.time > latestLine.time)
						latestLine = line;
				}
				cells.push({x: i, y: j, pid: latestLine.pid});
			}
		}
	}
	if(existingCells) {
		const newCells = [];
		for(let i of cells) {
			if(!existingCells.find(j => j.x===i.x && j.y===i.y))
				newCells.push(i);
		}
		return newCells;
	}
	return cells;
}


const nextTurn = (lines, count, people, turn, hasCells) => {
	if(lines.length===2*count*(count+1))
		return null;
	if(hasCells)
		return turn;
	const turnIndex = turn!==null?people.findIndex(p => p.pid===turn):people.length-1;
	let nextTurnIndex;
	for(let i=1; i<=people.length; i++) {
		nextTurnIndex = (turnIndex+i)%people.length;
		if(!people[nextTurnIndex].dead) return people[nextTurnIndex].pid;
	}
	return people[nextTurnIndex].pid;
}


class MessageEvent extends Event {
	constructor(message) {
		super("message")
		this.data = message;
	}
}

export default class BotController extends EventTarget {
	constructor({count, name}) {
		super();
		this.initData = {count, name};
		this.lines = [];
		this.cells = [];
		this.people = [];
		this.count = count;
		setTimeout(() => {
			this.dispatchEvent(new Event('open'));
		}, 100);
	}
	init() {
		this.people.push({pid: 0, name: this.initData.name, color: '#7bf'})
		this.respond({type: 'accepted', person: {pid: 0, color: '#7bf', self: true, name: this.initData.name}, game: {count: this.initData.count, gameid: 1}})
		this.respond({type: 'turn', pid: 0, sensors: true})
		const computer = {pid: 1, color: '#ea4', name: 'bot'}
		this.respond({type: 'person', person: computer})
		this.people.push(computer);
	}
	send(data) {
		if(data.type === "line") {
			this.lines.push({...data.line, time: Date.now()});
			const newCells = getCells(this.count, this.lines, this.cells);
			const turn = nextTurn(this.lines, this.count, this.people, this.turn, newCells.length?true:false)
			if(newCells.length)
				this.cells = [...this.cells, ...newCells];
			if(turn===1) {
				this.respond({type: 'turn', pid: 1});
				setTimeout(() => this.play(), 400);
			} else {
				this.respond({type: 'turn', pid: turn, sensors: true});
			}
		}
	}
	findLine(lines, drawnLines, filledCells, onlyFiller) {
		const cells = [];
		for(let i=0; i<this.count; i++) {
			for(let j=0; j<this.count; j++) {
				if(!filledCells.find(c => c.x===i && c.y===j))
					cells.push({x: i, y: j});
			}
		}
		let minLine = {count: 5, lines: []}, maxLine = {count: -1, lines: []}
		for(let l of lines) {
			const thenLines = [...drawnLines, l];
			const fillingCells = [];
			let maxLines = 0;
			for(let c of cells) {
				const lines = getLinesOfCell(this.count, thenLines, c.x, c.y)
				if(lines.find(l1 => l1.x===l.x && l1.y===l.y && l1.isH===l.isH)) {
					const count = lines.length;
					maxLines = Math.max(count, maxLines);
					if(count===4)
						fillingCells.push({...c})
				}
			}
			if(maxLines>maxLine.count)
				maxLine = {count: maxLines, line: {...l, fillingCells}};
			if(maxLines<minLine.count)
				minLine = {count: maxLines, lines: [l]};
			else if(maxLines===minLine.count)
				minLine = {count: maxLines, lines: [...minLine.lines, l]};
		}
		if(maxLine.count===4) return {...maxLine.line, time: Date.now(), pid: 1, filler: true}
		else if(onlyFiller) {
			// drawChart(drawnLines, filledCells, this.count);
			return {filler: false};
		} else if(minLine.count===3) {
			let takeLine = {line: null, future: this.count*this.count+1}
			for(const l of minLine.lines) {
				let future = 0;
				drawChart(drawnLines, filledCells, this.count, true)
				let cellsFilled = [...filledCells], linesDrawn = [...drawnLines, l], linesLeft = [...lines.filter(l1 => l1.x!==l.x||l1.y!==l.y||l1.isH!==l.isH)];
				drawChart(linesDrawn, cellsFilled, this.count)
				let line = this.findLine(linesLeft, linesDrawn, cellsFilled, true);
				let whileCount = 0;
				while(line.filler===true) {
					whileCount++;
					cellsFilled.push(...line.fillingCells)
					linesDrawn.push(line)
					linesLeft = [...linesLeft.filter(l1 => l1.x!==line.x||l1.y!==line.y||l1.isH!==line.isH)]
					drawChart(linesDrawn, cellsFilled, this.count)
					future++;
					line = this.findLine(linesLeft, linesDrawn, cellsFilled, true)
					if(whileCount>10)
						break;
				}
				if(takeLine.future > future)
					takeLine = {line: l, future}
			}
			return takeLine.line;
		} else return {...minLine.lines[0], time: Date.now(), pid: 1};
	}
	play() {
		clearChart();
		const linesLeft = [];
		for(let i=0; i<=this.count; i++) {
			for(let j=0; j<=this.count; j++) {
				if(j<this.count) {
					const existing = this.lines.find(l => l.isH && l.x===i && l.y===j)
					if(!existing)
						linesLeft.push({isH: true, x: i, y: j});
				}
				if(i<this.count) {
					const existing = this.lines.find(l => !l.isH && l.x===i && l.y===j)
					if(!existing)
						linesLeft.push({isH: false, x: i, y: j});
				}
			}
		}
		const line = this.findLine(linesLeft, this.lines, this.cells)
		this.lines.push(line);
		this.respond({type: 'line', line});
		const newCells = getCells(this.count, this.lines, this.cells);
		this.cells = [...this.cells, ...newCells];
		const turn = nextTurn(this.lines, this.count, this.people, 1, newCells.length?true:false)
		if(newCells.length)
			this.cells = [...this.cells, ...newCells];
		if(turn===1) {
			this.respond({type: 'turn', pid: 1});
			setTimeout(() => this.play(), 1000);
		} else {
			this.respond({type: 'turn', pid: turn, sensors: true});
		}
	}
	respond(data) {
		const e = new MessageEvent(data);
		if(data.type==='turn') this.turn = data.pid
		setTimeout(() => {
			this.dispatchEvent(e)
		}, 400);
	}
}
